import { NavSchema } from './Nav.styles';

export const navStyles: NavSchema = {
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    bg: 'blackAlpha.400',
    w: ['100% + 8px', null, '100%'],
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    borderRadius: ['none', null, 'md'],
    minH: '9',
    h: 'auto',
    px: '4',
    mx: ['-2', null, '0'],
    my: '3',
  },
  link: {
    boxShadow: 'none',
    border: 'none',
    fontSize: 'sm',
    textShadow: 'none',
    fontWeight: 'normal',
    lineHeight: '1.7',
    borderRadius: 'none',
    fontFamily: 'Staatliches',
    h: '10',
    color: 'white',
    borderBottom: '3px solid',
    borderBottomColor: 'transparent',
    px: '3',
    pt: '2',
    pb: '1',
    _hover: {
      textDecoration: 'none',
    },
    sx: {
      '&.active': {
        color: 'alpha.400',
        fontWeight: 'normal',
        textShadow: '0px 0px 8px rgba(255, 159, 28, 0.5)',
        border: 'none',
        borderBottom: '3px solid',
        borderBottomColor: 'alpha.400',
      },
    },
  },
};
